module.exports = __webpack_public_path__ + "static/p5-b1b9e2f1be06ce9a46741886dc45ec72.png";